import { calcImageUrl } from '../../util';

import { RhinoImage } from './types';

export function getAssetImageUrl(images: RhinoImage[], options: { height: number; type?: number; width: number }) {
  // we de a reverse to maintain backward compatibility
  // TODO: introduce type for channel logo
  const image = images.reverse().find((image) => image.type === options.type);

  if (!image) {
    return undefined;
  }

  return calcImageUrl(image.url, options.height, options.width);
}
